import { GenericoEnum } from './generico.enum';

export enum valorTipoComunicadosEnum {
    COMUNICADOS_CENTRUS = 1,
    COMUNICADOS_CONSELHOS_DELIBERATIVO = 2,
    INFORME_CENTRUS = 3,
    INFORME_DIRETORIA_DE_BENEFICIOS = 4,
    INFORME_CONSELHOS_DELIBERATIVO= 5
}

export class TipoComunicadosEnum {

    public static values = [
        { label: 'Selecione uma opção', value: null },
        { label: 'Comunicados Centrus', value: valorTipoComunicadosEnum.COMUNICADOS_CENTRUS },
        { label: 'Comunicados Conselhos Deliberativo', value: valorTipoComunicadosEnum.COMUNICADOS_CONSELHOS_DELIBERATIVO  },
        { label: 'Informe Centrus', value: valorTipoComunicadosEnum.INFORME_CENTRUS  },
        { label: 'Informe Diretoria De Benefícios', value: valorTipoComunicadosEnum.INFORME_DIRETORIA_DE_BENEFICIOS  },
        { label: 'Informe Conselhos Deliberativo', value: valorTipoComunicadosEnum.INFORME_CONSELHOS_DELIBERATIVO  }
    ]

    public static getObjByValues(value: any) {
    return GenericoEnum.getObjByValues(value, TipoComunicadosEnum.values);
}

    public static getDescricaoCompleta = (id: any) => {
    return GenericoEnum.getDescricaoCompleta(id, TipoComunicadosEnum.values);
};

    public static getValue = (id: boolean) => {
    return GenericoEnum.getValue(id, TipoComunicadosEnum.values);
}

    public static getNumberToBoolean = (valor: boolean): number => {
    if (valor  ===  true) {
        return 1;
    }
    return 0;
};

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/tipo-comunicados.enum.ts